import {
    UPDATE_ACCESS_LOG,
    APPEND_ACCESS_LOG,
    PREPEND_ACCESS_LOG,
    FETCH_MORE_LOGS
} from 'store/actions/types';

const initialState = {
    accessLog: [],
    hasMore: true,
    loading: false,
    filters: {
        access_type: '',
        strSearch: '',
        dateFrom: null,
        dateTo: null,
        consumer_id: '',
        property_id: '',
        success: ''
    },
    lastAccessTime: null
};

export default function accessReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_MORE_LOGS: {
            return {
                ...state,
                loading: true
            };
        }

        case UPDATE_ACCESS_LOG: {
            const newLogs = action.payload || [];
            return {
                ...state,
                accessLog: newLogs,
                loading: false,
                hasMore: newLogs.length >= 20,
                lastAccessTime: newLogs.length
                    ? newLogs[newLogs.length - 1].access_time
                    : null
            };
        }

        case APPEND_ACCESS_LOG: {
            const moreLogs = action.payload || [];
            const combined = [...state.accessLog, ...moreLogs];
            return {
                ...state,
                loading: false,
                accessLog: combined,
                hasMore: moreLogs.length >= 20,
                lastAccessTime: moreLogs.length
                    ? moreLogs[moreLogs.length - 1].access_time
                    : state.lastAccessTime
            };
        }

        case PREPEND_ACCESS_LOG: {
            const newLogs = action.payload || [];
            const existingIds = new Set(state.accessLog.map(log => log.logItemId));
            const uniqueLogs = newLogs.filter(log => !existingIds.has(log.logItemId));
            return {
                ...state,
                accessLog: [...uniqueLogs, ...state.accessLog]
            };
        }

        default:
            return state;
    }
}
